import { Component } from "../../../../base/Component";
import { Table } from "../../Table";

export type EnabledInTableHeader = EnabledInTableHeaderValues | EnabledInTableHeaderMethod;
export type EnabledInTableHeaderMethod = ((component: Component, table: Table) => boolean);

/**
 * This enum is used to control when a component residing in any of the table header tool panels is enabled, based on
 * the number of rows that are currently selected in the table.
 */
export enum EnabledInTableHeaderValues {
    ALWAYS = "alwaysEnabled", // Enables the component regardless of the number of rows selected
    ONE_ROW_SELECTED = "oneRowSelected", // Enables the component when one row is selected
    MULTIPLE_ROWS_SELECTED = "multipleRowsSelected", // Enables the component when > 1 row is selected
    ONE_OR_MORE_ROWS_SELECTED = "oneOrMoreRowsSelected", // Enables the component when 1 or more rows are selected
    ROWS_PRESENT = "rowsPresent" // Enables the component when at least one row is present in the table
}
